import { useQuery } from "@tanstack/react-query";
import { inventoryItemRepository } from "../repositories/inventoryItem.repository";

export const inventoryItemByIdQueryKey = (inventoryItemId: string) => [
  "inventory-item",
  inventoryItemId,
  "detail",
];

export function useInventoryItemByIdQuery(inventoryItemId: string) {
  return useQuery({
    queryKey: inventoryItemByIdQueryKey(inventoryItemId),
    queryFn: () =>
      inventoryItemRepository.getInventoryItemById(inventoryItemId),
    enabled: !!inventoryItemId,
    staleTime: 1000 * 60 * 5,
    gcTime: 60 * 60 * 1000,
    refetchOnMount: "always",
  });
}
